<template>
  <div class="operations-tab">
    <v-data-table
      :headers="headers"
      :items="operations"
      fixed-header
      hide-default-footer
      height="500"
      :items-per-page="-1"
      class="mb-6"
    >
      <template #top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Opérations</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template #activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nouveau</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-validate="'required'"
                        data-vv-name="label"
                        :error="errors.has('label')"
                        v-model="editedItem.label"
                        label="Nom"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="save"
                  >Enregistrer</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- Actions -->
      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import OperationRepo from "@/repositories/settings/operations";

  export default {
    name: "OperationsTab",
    data() {
      return {
        headers: [
          {
            text: "Libellé",
            align: "left",
            value: "label"
          },

          {
            text: "Actions",
            value: "action",
            sortable: false
          }
        ],

        operations: [],

        defaultItem: {
          label: ""
        },

        dialog: false,
        editedId: -1,
        editedItem: {
          label: ""
        }
      };
    },
    computed: {
      formTitle() {
        return this.editedId === -1
          ? "Ajouter une opération"
          : "Modifier une opération";
      }
    },
    methods: {
      editItem(item) {
        this.editedId = item.id;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      /**
       * Delete an operation
       */
      async deleteItem(item) {
        confirm("Voulez-vous supprimer cette opération?") &&
          (await OperationRepo.deleteOperation(item.id));

        this.getOperations();
      },

      /**
       * Save operation on server
       */
      async save() {
        // Check if form is valid
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          return;
        }

        if (this.editedId > -1) {
          await OperationRepo.updateOperation(this.editedId, this.editedItem);
        } else {
          await OperationRepo.create(this.editedItem);
        }

        this.getOperations();
        this.close();
      },

      /**
       * Close dialog and reset edited item
       */
      close() {
        this.dialog = false;
        this.errors.clear();
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedId = -1;
        }, 300);
      },

      /**
       * Get all operations
       */
      async getOperations() {
        try {
          const { data } = await OperationRepo.get();
          this.operations = data;
        } catch (error) {
          alert(error);
        }
      }
    },
    created() {
      this.getOperations();
    }
  };
</script>

<style lang="scss">
  .supports-tab {
    .v-data-table__wrapper {
      height: 470px !important;
    }
    .total {
      p {
        text-align: right;
        color: #006064;
        font-weight: bold;
        font-size: 15px !important;
      }
    }
    .v-data-table table tr td {
      height: auto !important;
    }
    .v-data-table table tbody td .v-input .v-input__control .v-input__slot {
      height: auto !important;
    }
  }
</style>
